<template>
  <div>
    <a-spin :spinning="loading === 'loading'" class="video-template-list">
      <span v-if="!dataList.length" />
      <a-empty
        v-if="!dataList.length && loading !== 'loading'"
        :style="{
          margin: '32px 30px 0 0',
          flexGrow: 1,
          opacity: loading === 'loading' ? 0 : 1,
          transition: '.3s',
        }"
        :image="defaultImage"
      />
      <div
        v-for="item in dataList"
        v-show="!isCollect || (isCollect && item.is_collect) "
        :key="item.id"
        class="video-template-item"
        @click="templateClick(item)"
      >
        <img v-if="item.attribute_name == '标准'"
          title="标准"
          class="meal-icon"
          src="/preview/icon/user_meal1.png" alt="标准">
        <img v-else-if="item.attribute_name == '专业'"
          class="meal-icon"
          title="专业"
          src="/preview/icon/user_meal2.png" alt="专业">
        <img v-else-if="item.attribute_name == '旗舰'"
          class="meal-icon"
          title="旗舰"
          src="/preview/icon/user_meal3.png" alt="旗舰">
        <img
          v-if="item.thumbnail"
          :src="item.thumbnail + '?x-oss-process=image/resize,w_216'"
          alt="Fragment Preview"
          class="video-clip-custom-img"
        />
        <img
          v-else
          class="video-clip-custom-img"
          src="//aivideo8.oss-cn-hongkong.aliyuncs.com/ai_video/U71-2020-05-08-img-1588927160629.png?x-oss-process=image/resize,w_216"
        />
        <img
          src="/preview/icon/video-preview.png"
          @click.stop="handlePreview(item)"
          alt="Preview"
          class="preview-icon"
          v-if="item.qurl || item.type === 6"
        />
        <span v-if="isCollect" @click.stop="starClick(item)" class="tem_used_icon" :class="{block: item.is_collect}" :title="item.is_collect?'取消收藏':'收藏'" :style="{'background-image':item.is_collect ? 'url(/preview/icon/icon_collected.png)' : 'url(/preview/icon/icon_collect.png)'}"></span>
        <div :title="item.name" class="video-clip-custom-title">
          {{ item.name }}
        </div>
      </div>
    </a-spin>
    <a-modal
      :bodyStyle="{ padding: 0, height: '450px' }"
      :centered="true"
      :footer="null"
      :title="false"
      :width="800"
      class="material-preview"
      v-model="modalVisible"
    >
      <video
        v-if="modalVisible"
        :src="modalVisible.qurl"
        class="preview-material"
        controls="controls"
        ref="materialVideo"
      ></video>
    </a-modal>
  </div>
</template>

<script>
import { Empty } from 'ant-design-vue';
import { mapActions } from 'vuex';
export default {
  props: ['dataList', 'loading', 'isCollect'],
  data(){
    return {
      modalVisible: false,
      defaultImage: Empty.PRESENTED_IMAGE_SIMPLE,
    }
  },
  methods: {
    ...mapActions([
      'applyVideoTemplate',
      'delCollect',
      'addCollect'
    ]),
    handlePreview(item) {
      if (item.type === 6 && !item.qurl) {
        this.$store.dispatch('previewCustomTemplate', item.id);
      } else {
        this.modalVisible = item;
      }
    },
    templateClick(item) {
      if (item.noAccess) {
        this.$store.commit('handleMealDialogVisible', true);
        return;
      }
      this.applyVideoTemplate(item)
    },
    // 点击收藏
    async starClick(item) {
      if (item.is_collect) {
        // 取消
        await this.delCollect({ type: 'template', id: item.id })
        this.$set(item, 'is_collect', false)
      } else {
        // 收藏
        await this.addCollect({ type: 'template', id: item.id })
        this.$set(item, 'is_collect', true)
      }
    },
  }
}
</script>

<style scoped>
.video-template-list {
  overflow: hidden;
}

.video-template-item {
  margin: 0 14px 20px 0;
  width: 108px;
  position: relative;
}



.video-clip-custom-img {
  object-fit: cover;
  width: 100%;
  height: 60px;
}

.preview-icon {
  position: absolute;
  right: 2px;
  bottom: 24px;
}
.video-template-item:hover .tem_used_icon, .tem_used_icon.block{
  display: block;
}
.tem_used_icon{
  display: none;
  vertical-align: middle;
  width: 20px;
  height: 20px;
  background-repeat: no-repeat;
  background-size: 100% 100%;
  background-position: center 0;
  cursor: pointer;
  position: absolute;
  top: 2px;
  right: 2px;
  z-index: 1;
}

.meal-icon{
  width: 20px;
  position: absolute;
  left: 0;
  top: 0;
  z-index: 1;
}

.video-clip-custom-title {
  text-align: center;
  font-size: 12px;
  font-weight: 400;
  /* color: rgba(0, 0, 0, 0.65); */
  margin: 4px 0 0;
  white-space: nowrap;
  overflow: hidden;
  text-overflow: ellipsis;
}

.preview-material {
  width: 800px;
  height: 450px;
}
</style>